"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const getPhProductsQtyAndPrice_1 = __importDefault(require("./getPhProductsQtyAndPrice"));
const isCartHasRestrictedMix = (lineItems) => {
    const phProductsQtyAndAmount = getPhProductsQtyAndPrice_1.default(lineItems);
    const { physicalProductsQty, physicalSubscriptionQty } = phProductsQtyAndAmount;
    // - only one physical subscription allowed
    // - only one physical product type allowed
    return Boolean(physicalProductsQty && physicalSubscriptionQty) || physicalSubscriptionQty > 1;
};
exports.default = isCartHasRestrictedMix;
//# sourceMappingURL=isCartHasRestrictedMix.js.map